export default {"frames": [

{
	"filename": "bubble_01.png",
	"frame": {"x":1,"y":467,"w":18,"h":17},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":554,"y":424,"w":18,"h":17},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "bubble_02.png",
	"frame": {"x":104,"y":165,"w":43,"h":50},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":544,"y":387,"w":43,"h":50},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "bubble_03.png",
	"frame": {"x":175,"y":127,"w":56,"h":91},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":544,"y":353,"w":56,"h":91},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "bubble_04.png",
	"frame": {"x":175,"y":1,"w":60,"h":124},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":544,"y":313,"w":60,"h":124},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "bubble_05.png",
	"frame": {"x":104,"y":1,"w":69,"h":162},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":537,"y":275,"w":69,"h":162},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "bubble_06.png",
	"frame": {"x":1,"y":258,"w":98,"h":207},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":506,"y":230,"w":98,"h":207},
	"sourceSize": {"w":1024,"h":1024}
},
{
	"filename": "bubble_07.png",
	"frame": {"x":1,"y":1,"w":101,"h":255},
	"rotated": false,
	"trimmed": true,
	"spriteSourceSize": {"x":484,"y":182,"w":101,"h":255},
	"sourceSize": {"w":1024,"h":1024}
}],
"meta": {
	"app": "https://www.codeandweb.com/texturepacker",
	"version": "1.0",
	"image": "bubbles.png",
	"format": "RGBA8888",
	"size": {"w":256,"h":512},
	"scale": "1",
	"smartupdate": "$TexturePacker:SmartUpdate:1012918bf6d678906a3c7b8922599532:9d03a0d1b19269b1c7b03e660adc91a9:bca2200893a80f12811007d61ceaffd1$"
}
}
